<template>
    <div class="mb-5">
        <h4 class="mb-3">Notes</h4>
        <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 10 }"
            v-model="fulfillment.fulfillment_notes">
        </el-input>

        <div class="mt-2">
            <btn :click="save" v-if="! readonly">Save</btn>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'fulfillment',
            'readonly',
        ],
        methods: {
            save() {
                return axios.post(url(`de/fulfillment/${this.fulfillment.id}/notes`), {
                    notes: this.fulfillment.fulfillment_notes
                }).then((response) => {
                    this.$emit('changed');
                });
            },
        },
        mounted() {
        },
        created() {
        },
    }
</script>
